import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbKategorieTyp } from '../../pages/parkbewilligungen/parkbewilligungen-data';

import moment from 'moment';

@Component({
  selector: 'pbkundelistitem',
  templateUrl: 'pbkundelistitem.html'
})
export class PbkundelistitemComponent {
  _pbkunde:any;
  @Input('pbkunde') 
  get pbkunde(): number {
    return this._pbkunde;
  }
  set pbkunde(value: number) {
    this._pbkunde = value;    
  }      


  @Output() pbkundeSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public pbData: ParkbewilligungenData,
    public userData: UserData
    ) {

  }

  select(){
    if(this.pbkundeSelected){
      this.pbkundeSelected.emit(this._pbkunde);
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/pbkundelistitem/pbkundelistitem.ts